import { theme } from 'modules/ui';
import { ParagraphTitle } from 'modules/ui/typography/Typography';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const FormSectionTitle = styled(ParagraphTitle)`
  color: ${theme.colors.primaryK4};
  margin: 2.825rem 0 1.325rem 0;

  ${mediaQuery('md')} {
    margin: 3.625rem 0 1.875rem 0;
  }
`;
